<template>
  <div :class="{ 'navigation-menu--collapsed': !expanded }" class="navigation-menu">
    <div class="navigation-menu__header">
      <ButtonSquare
        :imgSource="buttonImgSource"
        class="navigation-menu__toggle"
        :class="{ 'navigation-menu__toggle--collapsed': !expanded }"
        @clicked="handleToggleMenu"
      />
      <slot name="search" />
    </div>
    <div v-show="expanded" class="navigation-menu__content">
      <slot />
    </div>
    <div v-show="expanded" class="navigation-menu__footer"></div>
  </div>
</template>

<script>
import ButtonSquare from '../buttons/ButtonSquare/ButtonSquare.vue'
import { mapMutations } from 'vuex'
import { SET_MENU_EXPANDED } from '@/store/mutation-types'
import { getRealmId } from '@/utils/realmId'
import iconCross from '@/assets/icon-cross.png'
import iconHamburger from '@/assets/icon-hamburger.svg'
export default {
  name: 'NavigationMenu',
  components: {
    ButtonSquare
  },
  props: {
    expanded: {
      type: Boolean,
      default: false
    }
  },
  emits: ['onToggleClick'],
  data() {
    return {
      crossSource: iconCross,
      hamburgerSource: iconHamburger
    }
  },
  computed: {
    buttonImgSource() {
      return this.expanded ? this.crossSource : this.hamburgerSource
    },
    realmId() {
      return getRealmId()
    }
  },
  methods: {
    handleToggleMenu() {
      this.setMenuExpanded({ menuExpanded: !this.menuExpanded })
      this.$emit('onToggleClick')
    },
    ...mapMutations({
      setMenuExpanded: SET_MENU_EXPANDED
    })
  }
}
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
@use '@/styles/variables.scss' as old-variables;

.navigation-menu {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 64px;
  top: 2px + variables.$layout-top-bar-height;
  background-color: old-variables.$color-background-navigation-menu;
  padding: old-variables.$margin-small;
  width: old-variables.$width-app-navigation-menu;
  min-width: old-variables.$min-width-app-navigation-menu;
  z-index: variables.$z-index-navigation-menu;
  height: calc(85vh - #{old-variables.$margin-medium} - #{variables.$layout-top-bar-height});
  border-radius: old-variables.$margin-small;
  &--collapsed {
    background-color: transparent;
    height: 0;
    overflow: visible;
  }
  &__toggle {
    margin-right: 6px;
    z-index: variables.$z-index-navigation-menu-items;
  }
  &__header {
    display: flex;
    justify-content: space-between;
    height: old-variables.$size-button-medium;
    margin-bottom: old-variables.$margin-small;
    width: 40px;
    z-index: variables.$z-index-navigation-menu-items;
  }
  &__content {
    height: 100%;
    overflow: scroll;
    width: 100%;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  &__footer {
    margin-bottom: 0;
    margin-top: auto;
  }
}
@media screen and (max-width: 1024px) {
  .navigation-menu {
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(47, 54, 59);
    padding: variables.$padding-main-body - 12px variables.$padding-main-body
      variables.$padding-main-body variables.$padding-main-body + 54px;
    width: 100vw;
    z-index: variables.$z-index-navigation-menu;
    height: calc(100% - #{variables.$view-buttons-height});
    border-radius: 0;
    overflow: hidden;

    &--collapsed {
      position: absolute;
      background-color: transparent;
      height: 0;
      overflow: visible;
      top: 0;
      width: 0;
    }

    &__toggle {
      margin: 0 old-variables.$margin-small 0 0;
      padding: 0;
      z-index: 10;
    }

    &__header {
      display: flex;
      justify-content: space-between;
      height: old-variables.$size-button-medium;
      margin-bottom: old-variables.$margin-small;
      margin-top: 4px;
    }

    &__content {
      align-items: stretch;
      position: static;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      height: 100%;
      width: 100%;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
    }

    &__footer {
      margin: 0;
    }
  }
}
</style>
